<template>
  <footer class="footer">
    <div class="footer__text">
      ABA.KG   ©2018
    </div>
  </footer>
</template>

<script>
export default {
  name: 'sFooter'
}
</script>

<style>
  .footer{
    margin-bottom:25px;
    margin-top:150px;
  }
  .footer__text{
    font-size: 14px;
    font-weight: 300;
    color:#fff;
    text-align:center;


  }

  @media (min-width: 995px) and (min-height: 851px){
    .footer{
      position: fixed;
      bottom: 25px;
      left: calc(50% - 43px);
      margin: 0;
    }
  }
</style>




// WEBPACK FOOTER //
// sFooter.vue?47e311ad